import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import { autoHyperlinkHtml, formateDate, showStatus } from "../../../../../utils/commonfunction";
import * as consentServices from "../../../services/consent.services";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";

const ConsentView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "User Consent Management", url: "/admin/cms/consent/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    consentServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const getConsentTypeLabel = (type) => {
    switch (type) {
      case "PARENT_LINK_CONSENT":
        return "Parent Link Consent";
      case "PARENT_LINK_CONSENT_TEEN":
        return "Parent Link Consent Teen";
      case "SELF_CONSENT_17":
        return "Self Consent 17";
      case "ADULT_CONSENT_18_PLUS":
        return "Adult Consent 18 Plus";
      case "MARKETING":
        return "Marketing Consent";
      case "CLUB_ADMIN_CONSENT":
        return "Club Admin Consent";
      case "PARENT_SELF_CONSENT":
        return "Parent Self Consent";
      case "PRIVACY_POLICY":
        return "Privacy Policy";
      case "TERMS_CONDITIONS":
        return "Terms Conditions";
      case "DATA_PROTECTION":
        return "Data Protection";
      case "SAFE_GUARD_POLICY":
        return "Safe Guard Policy";
      default:
        return type || "N/A";
    }
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View User Consent Configuration</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table table-bordered table-hover"
                    >
                      <tbody>
                        <tr>
                          <th>Consent Title</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault?.title ? showdefault.title : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Version</th>
                          <td>
                            {showdefault && showdefault.version ? showdefault.version : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Consent Type</th>
                          <td>
                            {showdefault && showdefault.type ? getConsentTypeLabel(showdefault.type) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td>
                            {showdefault && showdefault?.status ? toHtml(showStatus(showdefault.status)) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>
                            {showdefault && showdefault.createdAt
                              ? formateDate(showdefault.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_modified_date")}</th>
                          <td>
                            {showdefault && showdefault?.updatedAt
                              ? formateDate(showdefault.updatedAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <h6 className="main-content-label mb-3 mt-4">Consent Text / Policy Details:</h6>
                    <div
                      style={{
                        padding: "15px",
                        border: "1px solid #dee2e6",
                        borderRadius: "8px",
                        backgroundColor: "#f8f9fa",
                        minHeight: "150px"
                      }}
                      dangerouslySetInnerHTML={{
                        __html: showdefault && showdefault?.description ? autoHyperlinkHtml(showdefault.description) : "N/A",
                      }}
                    ></div>
                   
                    <div className="mt-5">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsentView;
